import { render, staticRenderFns } from "./quartzManage.vue?vue&type=template&id=1c3ba334&"
import script from "./quartzManage.vue?vue&type=script&lang=js&"
export * from "./quartzManage.vue?vue&type=script&lang=js&"
import style0 from "./quartzManage.vue?vue&type=style&index=0&id=1c3ba334&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports